// 应用路由
const routers = [
  {
    path: "demo",
    name: "demo",
    meta: { hidden: false },
    component: () => import("@/views/demo.vue"),
  },
  {
    // 任务管理
    path: "/taskList",
    name: "taskList",
    meta: { hidden: false },
    component: () => import("@/views/TaskList/index.vue"),
  },
  {
    // 任务结果管理
    path: "/taskResult",
    name: "taskResult",
    meta: { hidden: false },
    component: () => import("@/views/TaskResult/index.vue"),
  },
  {
    // 执行结果
    path: "/executionResult",
    name: "executionResult",
    meta: { hidden: false },
    component: () => import("@/views/ExecutionResult/index.vue"),
  },
  {
    // 考勤明细
    path: "/attendanceList",
    name: "attendanceList",
    meta: { hidden: false },
    component: () => import("@/views/AttendanceList/index.vue"),
  },
  {
    path: "/tenantContractAuth",
    name: "tenantContractAuth",
    meta: { hidden: false },
    component: () => import("@/views/TenantContractAuth/index.vue"),
  },
  // 模板列表
  {
    path: "/templateConfigList",
    name: "TemplateConfigList",
    meta: { hidden: false },
    component: () => import("@/views/TemplateConfig/List.vue"),
  },
  // 模板详情
  {
    path: "/templateConfigDetail",
    name: "TemplateConfigDetail",
    meta: { hidden: false },
    component: () => import("@/views/TemplateConfig/Detail.vue"),
  },

  {
    path: "/person",
    name: "person",
    meta: { hidden: false },
    component: () => import("@/views/fdm/person/index.vue"),
  },
  {
    path: "/project",
    name: "project",
    meta: { hidden: false },
    component: () => import("@/views/fdm/project/index.vue"),
  },
  {
    path: "/tenant",
    name: "tenant",
    meta: { hidden: false },
    component: () => import("@/views/fdm/tenant/index.vue"),
  },
  {
    path: "/tenantManage",
    name: "tenantManage",
    meta: { hidden: false },
    component: () => import("@/views/fdm/tenantManage/index.vue"),
  },
  {
    path: "/pmdAppCompare",
    name: "pmdAppCompare",
    meta: { hidden: false },
    component: () => import("@/views/report/appCompare/pmdAppCompare.vue"),
  },
  {
    path: "/pmdAttCompare",
    name: "pmdAttCompare",
    meta: { hidden: false },
    component: () => import("@/views/report/attCompare/pmdAttCompare.vue"),
  },
  {
    path: "/pmdFaceCompare",
    name: "pmdFaceCompare",
    meta: { hidden: false },
    component: () => import("@/views/report/faceCompare/pmdFaceCompare.vue"),
  },
  {
    path: "/pmdTaskCompare",
    name: "pmdTaskCompare",
    meta: { hidden: false },
    component: () => import("@/views/report/taskCompare/pmdTaskCompare.vue"),
  },
  {
    path: "/pmdCrmAuth",
    name: "pmdCrmAuth",
    meta: { hidden: false },
    component: () => import("@/views/report/crmAuth/pmdCrmAuth.vue"),
  },
  {
    path: "/miniprogram",
    name: "miniprogram",
    meta: { hidden: false },
    component: () => import("@/views/fdm/miniprogram/index.vue"),
  },
  {
    path: "/miniprogramTenant",
    name: "miniprogramTenant",
    meta: { hidden: false },
    component: () => import("@/views/fdm/miniprogramTenant/index.vue"),
  },
  // 开封小票识别记录
  {
    path: "/ocrLog",
    name: "OcrLog",
    meta: { hidden: false },
    component: () => import("@/views/OcrLog/index.vue"),
  },

  // 触点结算单开通配置
  {
    path: "/settlementConfig",
    name: "SettlementConfig",
    meta: { hidden: false },
    component: () => import("@/views/fdm/SettlementConfig/index.vue"),
  },
  // 触点结算单开通配置
  {
    path: "/aiResult",
    name: "AIResult",
    meta: { hidden: false },
    component: () => import("@/views/AIResult/index.vue"),
  },

  {
    path: "/projectConfig",
    name: "projectConfig",
    meta: { hidden: false },
    component: () => import("@/views/Config/projectConfig/index.vue"),
  },
  {
    path: "/actProjectConfig",
    name: "actProjectConfig",
    meta: { hidden: false },
    component: () => import("@/views/Config/actProjectConfig/index.vue"),
  },
  // 业务财务平台项目白名单配置
  {
    path: "/projectWhitelist",
    name: "projectWhitelist",
    meta: { hidden: false },
    component: () => import("@/views/Config/projectWhitelist/index.vue"),
  },
];
export default routers;
